/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import keyboard from 'keycode-ui';
import PubSub from 'pubsub-js';

/*---------------------------------------------------------*\
 * Constants
\*---------------------------------------------------------*/
const deps = {};

/*---------------------------------------------------------*\
 * CameraGallery
\*---------------------------------------------------------*/
class CameraGalleryController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($scope, $state, $element, $interval, navigationService, topics, states) {
    this.name = 'cameraGallery';

    deps.$scope = $scope;
    deps.$state = $state;
    deps.$element = $element;
    deps.$interval = $interval;
    deps.navigationService = navigationService;
    deps.topics = topics;
    deps.states = states;
    deps.$scope.$on('$destroy', () => {
      deps.$interval.cancel(this.promise);
    });
  }

  //-----------------------------------
  // Lifecycle
  //-----------------------------------
  $postLink() {
    this.selectImage(this.cameras.index);
    const currentClass = this.enlarged ? 'back-button' : 'enlarge-button';
    deps.navigationService.focusElAsync(`.${currentClass}`);
  }

  //-----------------------------------
  // Methods
  //-----------------------------------

  selectImage(index) {
    if (index < 0 || index >= this.cameras.length) {
      return;
    }

    // Create temporary image attribute so we can load the image and display
    // loading while it is coming in.
    const img = document.createElement('img');

    this.cameras.selIndex = index;
    this.loading = true;
    this.error = false;

    img.addEventListener('load', () => {
      this.loading = false;
      deps.$scope.$apply();
    });

    img.addEventListener('error', () => {
      this.error = true;
      this.loading = false;
      deps.$scope.$apply();
    });
    this.promise = deps.$interval(() => {
      this.refreshImage(this.cameras.selIndex);
    }, 10000);
    img.src = this.cameras[this.cameras.selIndex].CameraURL;
    deps.navigationService.focusElAsync('.main-content');
  }

  enlargeGallery() {
    this.modal = false;
    this.cameras.showCamerasPhotos = false;
    this.cameras.showCameras = true;
    PubSub.publish(deps.topics.component.selectPhotos, this.cameras);
    // this.modal = true;
    // deps.navigationService.focusElAsync('.back-button');
  }

  goBack() {
    this.modal = false;
    deps.navigationService.focusElAsync('navbar');
  }

  refreshImage(index) {
    this.updatetime = new Date().getTime();
    const imgrefresh = 'background-image: url(' + this.cameras[index].CameraURL +
        '&' + this.updatetime + ')';
    document.getElementById('imgrefresh').setAttribute('style', imgrefresh);
  }

  //-----------------------------------
  // Events
  //-----------------------------------
  keydownHandler(e) {
    if (keyboard.isLeft(e)) {
      e.preventDefault();

      const newIndex = this.cameras.selIndex - 1;
      if (newIndex > -1) {
        deps.$interval.cancel(this.promise);
        this.selectImage(newIndex);
        // change ads
        this.changeAds();
      } else {
        PubSub.publish(deps.topics.nav.left, 'camera-gallery');
      }
    } else if (keyboard.isRight(e)) {
      e.preventDefault();
      const newIndex = this.cameras.selIndex + 1;
      if (newIndex === this.cameras.length) {
        this.selectImage(this.cameras.selIndex + 1);
      } else {
        deps.$interval.cancel(this.promise);
        this.selectImage(this.cameras.selIndex + 1);

        // change ads
        this.changeAds();
      }
    } else if (keyboard.isUp(e)) {
      e.preventDefault();
      PubSub.publish(deps.topics.nav.up, 'camera-gallery');
    } else if (keyboard.isEnter(e)) {
      this.enlargeGallery();
    }
  }

  keyUp(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (keyboard.isBack(e)) {
      this.goBack();
    }
  }

  changeAds() {
    // change ads only when in small view
    if (!this.enlarged) {
      PubSub.publish(deps.topics.ads.refreshAd);
    }
  }
}

CameraGalleryController.$inject = [
  '$scope',
  '$state',
  '$element',
  '$interval',
  'navigationService',
  'topics',
  'states'
];

export default CameraGalleryController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/cameraGallery/cameraGallery.controller.js
 **/